<template>
    <div class="menu-mix">
        <div class="login-area">
            <div v-if="store.token" class="login-user">
                <div class="avatar" @click="goProfile"><img :src="store.userInfo?.avatar" /></div>
                <div class="user-info">
                    <div class="user-id">ID:{{ store.userInfo?.uid }}<span @click="handleCopy(store.userInfo?.uid)"></span></div>
                    <div class="user-name elipsis">{{ store.userInfo?.nickname && decode(`${store.userInfo?.nickname}`) }}</div>
                </div>
            </div>

            <div v-else class="login" @click="handleLogin">{{ $t('Not_logged_in_prompt') }}</div>
        </div>
        <div class="menu-vip-0" v-if="Object.keys(vipInfo).length && vipInfo.curLevel == 0" @click="navigateToVip">
            <div class="icon"><img v-lazy="VipIcon0" /></div>
            <div class="text">
                <div>Deposit</div>
                <div>To Unlock VIP</div>
            </div>
        </div>
        <div
            v-else-if="Object.keys(vipInfo).length"
            :class="[
                `menu-vip vip-${vipInfo.curLevel}`,
                { 'show-bot': vipInfo.curLevel >= 1, 'vip-animate': vipInfo?.levelUpReward?.length || vipInfo?.monthReward },
            ]"
            @click="navigateToVip"
        >
            <div class="vip-top">
                <div class="vip-icon"></div>
                <div class="vip-grade">{{ vipInfo.curLevel }}</div>
                <div class="vip-bar">
                    <div class="bar-text">
                        {{
                            $t(
                                vipInfo.lockLevelUp ? 'card_restore_goal' : 'card_upgrade_goal',
                                vipInfo.lockLevelUp
                                    ? { maxlevel: vipInfo.maxLevel }
                                    : { level: vipInfo.curLevel < 12 ? vipInfo.curLevel + 1 : vipInfo.curLevel }
                            )
                        }}
                    </div>
                    <Bar
                        :num="vipInfo.lockLevelUp ? vipInfo.recoverExp : vipInfo.exp"
                        :target="vipInfo.lockLevelUp ? vipInfo.recoverMax : vipInfo.max"
                    />
                </div>
            </div>
            <div class="vip-bot">
                <p class="legal-text">{{ $t('info_reward') }}:</p>
                <div class="legal-wrap">
                    <template v-for="(item, index) in VIP_LEGAL_CONFIG" :key="index">
                        <div v-if="getKeyValue(levelConfig, item.key)" :class="['legal-item', `legal-item${index}`]">
                            <div class="legal-cion">
                                {{
                                    item.key !== 'benefit'
                                        ? item.type === 'percent'
                                            ? `${formatPercent(getKeyValue(levelConfig, item.key) || 0)}`
                                            : getKeyValue(levelConfig, item.key)
                                        : ''
                                }}
                            </div>
                            <p class="legal-name">{{ $t(item.text) }}</p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="domian">
            <div class="domain-center">
                <div class="domain-wallet" @click="goWallet" v-lazy:background-image="WALLET_BG">
                    <div class="wallet-info">
                        <div class="wallet-cy">{{ store.wallet?.currency }}</div>
                        <div class="wallet-gold">{{ store.curSymbol[store.wallet?.currency] }}{{ formatNumber(store.wallet?.gold || 0) }}</div>
                        <div class="wallet-bonus">
                            <span>Bonus:</span> {{ store.curSymbol[store.wallet?.currency] }}{{ formatNumber(store.wallet?.bonus || 0) }}
                        </div>
                    </div>
                </div>
                <div class="domain-message" @click="goMessage" v-lazy:background-image="MS_BG">
                    <div class="name">{{ $t('Home_Messages') }}</div>
                    <div v-if="store.noticeNum" :class="['unread-count', `unread-count${store.noticeNum}`]">
                        {{ store.noticeNum > 99 ? '99+' : store.noticeNum }}
                    </div>
                </div>
                <div class="domain-server" @click="goServer" v-lazy:background-image="SERVER_BG">
                    <div class="name">{{ $t('Customer_service') }}</div>
                </div>
                <div class="domain-recod" @click="handleRecord" v-html="$t('menu_game_record')" v-lazy:background-image="RECORD_BG"></div>
            </div>
        </div>
        <div :class="['domian-bind', { binded: store.userInfo?.telephone }]" @click="handleBind" v-lazy:background-image="PHONE_BG">
            {{ !store.userInfo?.telephone ? $t('menu_bind_phone') : $t('Already_bound') }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import { decode } from 'js-base64'
import { useClipboard1 } from '@/hooks/useCopy'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { formatNumber, formatPercent } from '@/utils/toolsValidate'
import eventBus from '@/utils/bus'
import { Log } from '@/api/log'
import Bar from '@/components/vip/bar.vue'
import { VIP_LEGAL_CONFIG } from '@/enums'
import { storeToRefs } from 'pinia'
import { getKeyValue } from '@/utils/index'
import MS_BG from '@/assets/img/new-home/ms_bg.png'
import WALLET_BG from '@/assets/img/new-home/wallet_bg.png'
import SERVER_BG from '@/assets/img/new-home/server_bg.png'
import RECORD_BG from '@/assets/img/new-home/record_bg.png'
import PHONE_BG from '@/assets/img/new-home/phone_bg.png'
import VipIcon0 from '@/assets/img/vip/badge/0.png'

const store = useBaseStore()

const router = useRouter()
const i18n = useI18n()
const { toClipboard } = useClipboard1()

const { vipInfo, vipConfig } = storeToRefs(store)

const levelConfig = computed(() => {
    return vipConfig.value.find((item) => item.level === vipInfo.value.curLevel + (vipInfo.value.levelUpReward ? 0 : 1))
})

const handleCopy = (text) => {
    Log({
        event: 'menu_ID',
    })
    toClipboard(`${text}`)
    showToast(i18n.t('Copy_successfully'))
}
const handleLogin = () => {
    Log({
        event: 'menu_sign',
    })
    router.push('/login')
}
const goWallet = () => {
    Log({
        event: 'menu_wallet',
    })
    router.push({
        path: '/wallets',
        query: {
            back: 1,
        },
    })
}
const goServer = () => {
    Log({
        event: 'menu_CS',
    })
    window.open('https://m.me/playtok1')
}
const handleRecord = () => {
    Log({
        event: 'menu_game_record',
    })
    eventBus.emit('menuSet', 'showRecord')
}
const handleBind = () => {
    Log({
        event: 'menu_bindphone',
    })
    eventBus.emit('menuSet', '/bindPhone')
}
const goMessage = () => {
    Log({
        event: 'menu_message',
    })
    router.push({
        path: '/message',
    })
}
const goProfile = () => {
    Log({
        event: 'menu_profile',
    })
    router.push({
        path: '/profile',
    })
}

function navigateToVip() {
    router.push('/vip')
}
</script>
<style lang="scss" scoped>
.menu-mix {
    margin-bottom: 40px;
    font-family: MicrosoftYaHei;
    font-size: 30px;

    color: #ffffff;

    .login-area {
        @apply flex items-center;
        margin-bottom: 16px;
        height: 108px;

        .login-user {
            @apply flex;
            width: 100%;

            .avatar {
                position: relative;
                margin-right: 24px;
                width: 100px;
                height: 100px;
                border-radius: 50%;
                border: 4px solid #444b5e;
                background: #595852;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                }
                &::after {
                    content: '';
                    position: absolute;
                    right: -4px;
                    bottom: -4px;
                    width: 32px;
                    height: 32px;
                    background: url('@/assets/img/new-home/edit.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
            .user-info {
                @apply flex flex-col justify-center;
                flex: 1;
                font-weight: bold;
                overflow: hidden;

                .user-id {
                    @apply flex items-center;

                    span {
                        margin-left: 12px;
                        display: inline-block;
                        width: 30px;
                        height: 32px;
                        background: url('@/assets/img/new-home/copy.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .user-name {
                    font-size: 28px;
                    color: #5d7585;
                }
            }
        }

        .login {
            margin: 0 auto;
            width: 320px;
            height: 64px;
            line-height: 64px;
            background-image: linear-gradient(0deg, #0e8e66 0%, #10c57f 100%), linear-gradient(#887afb, #887afb);
            background-blend-mode: normal, normal;
            border-radius: 12px;
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
        }
    }
    .menu-vip-0 {
        @apply flex items-center;
        width: 540px;
        height: 160px;
        padding: 0 19px;
        margin-bottom: 22px;
        background-image: linear-gradient(34deg, #dcb587 0%, #b17b4b 100%);
        box-shadow: inset 0px 3px 1px 0px rgba(250, 255, 163, 0.12);
        border-radius: 20px;

        .icon {
            width: 131px;
            height: 144px;
            margin-right: 29px;

            img {
                width: 100%;
                height: 100%;
            }
        }
        .text {
            flex: 1;
            font-family: MicrosoftYaHei;
            font-size: 41px;
            font-weight: bold;
            line-height: 38px;

            div {
                text-align: center;
                color: #fff;
                text-shadow: #a26937 2px 5px;

                &:first-child {
                    margin-bottom: 15px;
                }
            }
        }
        &::after {
            display: inline-block;
            content: '';
            width: 37px;
            height: 40px;
            background: url('@/assets/img/vip/arrow.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    .menu-vip {
        position: relative;
        margin-bottom: 20px;
        width: 540px;
        min-height: 123px;
        background: url('@/assets/img/vip/vip_card1.png') no-repeat top center;
        background-size: 100% 100%;

        // @for $i from 0 through 1 {
        //     &.vip-#{$i} {
        //         height: 123px;
        //         background-image: url('@/assets/img/vip/vip_card1.png');

        //         .vip-top {
        //             .vip-grade {
        //                 padding-top: 0;
        //                 top: 9px;
        //             }
        //         }
        //         .vip-bot {
        //             display: none;
        //         }
        //     }
        // }

        .vip-icon {
            position: absolute;
            right: 9px;
            top: -37px;
            width: 175px;
            height: 154px;

            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        @for $i from 0 through 12 {
            &.vip-#{$i} {
                .vip-icon {
                    background-image: url('@/assets/img/vip/badge/#{$i}.png');
                }
            }
        }
        .vip-top {
            height: 123px;

            .vip-grade {
                position: relative;
                padding: 0 0 0 95px;

                top: 9px;
                font-size: 36px;
                font-weight: bold;
            }
            .vip-bar {
                width: 370px;
                padding-left: 28px;
            }
            .bar-text {
                margin-bottom: 5px;
                font-size: 18px;
                color: #ffea76;
            }
        }
        .vip-bot {
            display: none;
            .legal-text {
                padding: 6px 0 4px 27px;
                font-size: 14px;
            }
            .legal-wrap {
                @apply flex;
                padding: 0 16px 0 20px;
                overflow-x: auto;

                .legal-item {
                    @apply flex-1 flex flex-col items-center;
                    margin-right: 20px;
                    .legal-cion {
                        @apply flex flex-col justify-start items-center;
                        width: 70px;
                        height: 75px;
                        padding-top: 5px;
                        padding-bottom: 2px;
                        background: url('@/assets/img/vip/legal_bg.png') no-repeat;
                        background-size: 100% 100%;

                        font-size: 14px;

                        &::before {
                            align-self: top;
                            content: '';
                            display: inline-block;
                            width: 60px;
                            height: 49px;
                            background-size: 100%;
                            background-repeat: no-repeat;
                        }
                    }
                    .legal-name {
                        margin-top: 3px;
                        font-size: 14px;
                        text-align: center;
                    }
                }
                @for $i from 0 through 6 {
                    .legal-item#{$i} {
                        .legal-cion {
                            &::before {
                                background-image: url(@/assets/img/vip/legal/icon_#{$i}.png);
                            }
                        }
                    }
                }
            }
        }
        &.show-bot {
            min-height: 260px;
            background-image: url('@/assets/img/vip/vip_card.png');

            .vip-top {
                .vip-grade {
                    top: 11px;
                    // padding-top: 5px;
                }
            }

            .vip-bot {
                display: block;
            }
        }
    }
    .domain-center {
        @apply grid grid-cols-2 gap-[20px];
        font-size: 26px;

        .domain-wallet,
        .domain-message,
        .domain-server,
        .domain-recod {
            padding: 16px 19px;
            height: 120px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .domain-message {
            position: relative;
            font-weight: bold;

            .unread-count {
                position: absolute;
                top: -12px;
                right: -10px;
                width: 36px;
                height: 36px;
                background: url('@/assets/img/chat/m_bg1.png') no-repeat;
                background-size: 100% 100%;
                font-size: 22px;
                font-weight: bold;
                color: #fff;
                text-align: center;
            }
            .unread-count2 {
                width: 46px;
                background-image: url('@/assets/img/chat/m_bg2.png');
            }
            .unread-count3 {
                width: 56px;
                background-image: url('@/assets/img/chat/m_bg3.png');
            }
        }

        .domain-recod {
            font-weight: bold;
        }
        .name {
            width: 160px;
            word-break: break-word;
            font-weight: bold;
        }

        .domain-wallet {
            font-weight: bold;
            .wallet-cy {
                font-size: 26px;
            }
            .wallet-gold {
                line-height: 30px;
                font-size: 28px;
                color: #ffea76;
            }
            .wallet-bonus {
                font-size: 18px;
                color: #ffea76;

                span {
                    color: #fff;
                }
            }
        }
    }
    .domian-bind {
        @apply flex items-center;
        margin-top: 20px;
        height: 100px;
        padding: 0 19px;

        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.binded {
            pointer-events: none;
            opacity: 0.6;
        }
    }
}
</style>
